import React from 'react';
import { ReactComponent as DrawIcon } from '@assets/icons/ShapesDrawingTools/draw.svg';

import './AnnotationShortcutHint.less';

function AnnotationShortcutHint() {
  return (
    <div className="annotation_shortcut_hint">
      <DrawIcon className="annotation_shortcut_hint__icon" />
      <span className="annotation_shortcut_hint__text">
        Press <div className="annotation_shortcut_hint__key">D</div> to annotate
      </span>
    </div>
  );
}

export default AnnotationShortcutHint;
